
import apiClient from './client';

export const MedicalIcdAxiosInstance = apiClient;
